module.exports = __webpack_public_path__ + "img/8-full-sm.514ac0fd.jpg";